export default {

	darkGreen: '#00272B',
	graniteGray: '#656565',
	smoke: '#758173',
	pastelGray: '#D0CEBA',
	floralWhite: '#F9FBF2'
	
}